import React, { Fragment } from "react";
import Empty from "components/Empty";
import { injectIntl } from "react-intl";
import { NumberFormatOptions } from "i18n/helpers";
import { chartOptions } from "redux/helpers";
import { Line } from "react-chartjs-2";
import "./component_style.css";

const StatItem = ({ CPM, cost, exposure, date, intl: { formatNumber } }) => (
  <tr>
    <td>{date}</td>
    <td>{(exposure && formatNumber(exposure)) || "-"}</td>
    <td>{(CPM && formatNumber(CPM, NumberFormatOptions)) || "-"}</td>
    <td>{formatNumber(cost / 1e5, NumberFormatOptions)}</td>
  </tr>
);

const StatTotal = ({ cost, exposure, intl: { formatNumber } }) => (
  <tr>
    <td>Итого:</td>
    <td>{(exposure && formatNumber(exposure)) || "-"}</td>
    <td />
    <td>{formatNumber(cost / 1e5, NumberFormatOptions)}</td>
  </tr>
);

const Stat = ({ items, intl, total, chartData }) => (
  <Fragment>
    {chartData && (
      <div className="charts">
        <Line options={chartOptions} data={chartData} height={300} />
      </div>
    )}
    <div className="overtable">
      <table className="table table1">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Показы</th>
            <th>CPM</th>
            <th>Доход</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <StatItem key={idx} {...item} intl={intl} />
          ))}
          <StatTotal {...total} intl={intl} />
        </tbody>
      </table>
    </div>
  </Fragment>
);

export default injectIntl(
  ({ items, intl, total, chartData }) =>
    items.length ? (
      <Stat total={total} chartData={chartData} items={items} intl={intl} />
    ) : (
      <Empty />
    )
);
